import styled, { css } from 'styled-components';
import { ReactComponent as ChevronLeft } from 'assets/images/ChevronLeft.svg';
import { ReactComponent as ChevronRight } from 'assets/images/ChevronRight.svg';
import { motion } from 'framer-motion';

interface ChevronButton {
  slide: number;
  ismobile: boolean;
}

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  .next,
  .prev {
    top: calc(50% - 20px);
    position: absolute;
    background: white;
    border-radius: 30px;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    cursor: pointer;
    font-weight: bold;
    font-size: 18px;
    z-index: 2;
  }

  .next {
    right: 10px;
  }

  .prev {
    left: 10px;
    transform: scale(-1);
  }

  @media screen and (max-width: 1000px) {
    overflow-y: auto;
  }
`;

export const Slide = styled(motion.div)`
  position: absolute;
  width: 100vw;
  height: 100vh;

  ::-webkit-scrollbar {
    display: none;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  @media screen and (max-width: 1000px) {
    height: 100%;
    min-height: 100vh;
    overflow-x: hidden;
  }
`;

export const IconLeft = styled(ChevronLeft)<ChevronButton>`
  fill: #fff;

  ${({ slide, ismobile }) =>
    [100].includes(slide) &&
    !ismobile &&
    css`
      fill: #000;
    `}

  ${({ slide, ismobile }) =>
    [100].includes(slide) &&
    ismobile &&
    css`
      fill: #000;
    `}
`;

export const IconRight = styled(ChevronRight)<ChevronButton>`
  fill: #fff;

  ${({ slide, ismobile }) =>
    [100].includes(slide) &&
    !ismobile &&
    css`
      fill: #000;
    `}

  ${({ slide, ismobile }) =>
    [100].includes(slide) &&
    ismobile &&
    css`
      fill: #000;
    `}
`;

export const ButtonPrev = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  position: absolute;
  left: 0;
  top: center;
  z-index: 99;

  &.slick-disabled {
    opacity: 0.5;
  }

  @media screen and (max-width: 1000px) {
    top: calc(50% - 8%);
  }
`;

export const ButtonNext = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  position: absolute;
  right: 0;
  top: center;
  z-index: 99;

  &.slick-disabled {
    opacity: 0.5;
  }

  @media screen and (max-width: 1000px) {
    top: calc(50% - 8%);
  }
`;
